import _asyncToGenerator from "D:/hjj/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "addProjectItem"
};
var _hoisted_2 = {
  class: "drawing_update"
};
var _hoisted_3 = {
  class: "opear"
};
import { ref, watch, nextTick } from "vue";
import _ from "lodash";
import { get_dictionary } from "@/api/apis";
import moment from "moment";
import { init } from "echarts";
export default {
  __name: 'addProjectItem',
  props: ["data"],
  emits: ["onUpdate"],
  setup(__props, _ref) {
    var {
      expose: __expose,
      emit: __emit
    } = _ref;
    var send_text = ref("");
    var props = __props;
    var emit = __emit;
    var formModel = ref({
      list: (props === null || props === void 0 ? void 0 : props.data) || []
    });
    var initTime = () => {
      formModel.value.list.map(x => {
        if (x.start && x.end) {
          x.time = [moment(x.start), moment(x.end)];
        }
      });
    };
    watch(() => {
      return props.data;
    }, newData => {
      formModel.value.list = Array.isArray(newData) ? newData : [];
      initTime();
    }, {
      immediate: true
    });
    var scaleList = ref([]);
    var stageList = ref([]);
    var typeList = ref([]);
    var getDicList = () => {
      get_dictionary({
        full_name: "研发阶段-关联客户"
      }).then(res => {
        if (res.code == 200) {
          stageList.value = (res.data.data || []).map(x => {
            return {
              value: x.encode,
              label: x.full_name
            };
          });
        }
      });
      get_dictionary({
        full_name: "项目类型-客户关联"
      }).then(res => {
        if (res.code == 200) {
          typeList.value = (res.data.data || []).map(x => {
            return {
              value: x.encode,
              label: x.full_name
            };
          });
        }
      });
      get_dictionary({
        full_name: "发酵规模"
      }).then(res => {
        if (res.code == 200) {
          scaleList.value = (res.data.data || []).map(x => {
            return {
              value: x.encode,
              label: x.full_name
            };
          });
        }
      });
    };
    getDicList();
    //新增
    var curDate = moment().format("YYYY-MM-DD");
    var yearLater = moment().add(12, "month").format("YYYY-MM-DD");
    var handle_add_row = () => {
      formModel.value.list.push({
        project: "",
        type: "其他",
        stage: "其他",
        scale: "非发酵/其他",
        time: [curDate, yearLater],
        remark: "",
        start: curDate,
        end: yearLater
      });
      emit("onUpdate", _.cloneDeep(formModel.value.list));
    };
    //删除
    var handle_del_row = index => {
      formModel.value.list.splice(index, 1);
      emit("onUpdate", _.cloneDeep(formModel.value.list));
    };
    var rules = {
      project: [{
        required: true,
        message: "请输入项目名称",
        trigger: ["blur", "change"]
      }],
      stage: [{
        required: true,
        message: "请选择研发阶段",
        trigger: ["blur", "change"]
      }],
      scale: [{
        required: true,
        message: "请选择发酵规模",
        trigger: ["blur", "change"]
      }],
      type: [{
        required: true,
        message: "请选择项目类型",
        trigger: ["blur", "change"]
      }],
      time: [{
        required: true,
        message: "请选择项目有效期",
        trigger: ["blur", "change"]
      }]
    };
    var changeTime = (val, index) => {
      if ((val === null || val === void 0 ? void 0 : val.length) > 1) {
        formModel.value.list[index].start = val[0] ? moment(val[0]).format("YYYY-MM-DD") : null;
        formModel.value.list[index].end = val[1] ? moment(val[1]).format("YYYY-MM-DD") : null;
      } else {
        formModel.value.list[index].start = null;
        formModel.value.list[index].end = null;
      }
    };
    var approvalRef = ref(null);
    var handleSelectValidation = (fieldName, index) => {
      if (!approvalRef.value) {
        return;
      }
      if (typeof approvalRef.value.validateField !== "function") {
        return;
      }
      try {
        var fieldPath = "list.".concat(index, ".").concat(fieldName);
        approvalRef.value.validateField(fieldPath, errorMessage => {
          if (errorMessage) {
            console.log("".concat(fieldName, " \u6821\u9A8C\u5931\u8D25:"), errorMessage);
          }
        });
      } catch (error) {
        console.error("校验出错:", {
          fieldName,
          index,
          error: error.message || "未知错误"
        });
      }
    };

    // 保留原有的 validateField 方法供外部调用
    var validateField = (fieldName, index) => {
      handleSelectValidation(fieldName, index);
    };
    var validateTable = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* () {
        try {
          yield approvalRef.value.validate();
          return true;
        } catch (error) {
          return false;
        }
      });
      return function validateTable() {
        return _ref2.apply(this, arguments);
      };
    }();
    __expose({
      approvalRef,
      validateTable,
      validateField
    });
    return (_ctx, _cache) => {
      var _component_el_table_column = _resolveComponent("el-table-column");
      var _component_el_input = _resolveComponent("el-input");
      var _component_el_form_item = _resolveComponent("el-form-item");
      var _component_el_option = _resolveComponent("el-option");
      var _component_el_select = _resolveComponent("el-select");
      var _component_el_date_picker = _resolveComponent("el-date-picker");
      var _component_el_popconfirm = _resolveComponent("el-popconfirm");
      var _component_el_table = _resolveComponent("el-table");
      var _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
        ref_key: "approvalRef",
        ref: approvalRef,
        model: formModel.value,
        rules: rules,
        "label-width": "210px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: formModel.value.list,
          style: {
            "width": "100%"
          },
          border: "",
          "empty-text": "请添加"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "",
            label: "序号",
            width: "70",
            align: "center"
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.$index + 1), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "project",
            label: "项目名称",
            width: "180",
            align: "center"
          }, {
            header: _withCtx(() => _cache[1] || (_cache[1] = [_createElementVNode("span", {
              class: "column-label"
            }, "*", -1), _createTextVNode("项目名称 ")])),
            default: _withCtx(scope => [_createVNode(_component_el_form_item, {
              rules: rules.project,
              prop: "list.".concat(scope.$index, ".project"),
              class: "s-label"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: scope.row.project,
                "onUpdate:modelValue": $event => scope.row.project = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 2
            }, 1032, ["rules", "prop"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "type",
            label: "项目类型",
            width: "160",
            align: "center"
          }, {
            header: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("span", {
              class: "column-label"
            }, "*", -1), _createTextVNode("项目类型 ")])),
            default: _withCtx(scope => [_createVNode(_component_el_form_item, {
              rules: rules.type,
              prop: "list.".concat(scope.$index, ".type"),
              class: "s-label"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: scope.row.type,
                "onUpdate:modelValue": $event => scope.row.type = $event,
                filterable: "",
                placeholder: "请选择",
                onBlur: () => validateField('type', scope.$index),
                onChange: () => validateField('type', scope.$index)
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.label
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "onBlur", "onChange"])]),
              _: 2
            }, 1032, ["rules", "prop"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "specification",
            label: "研发阶段",
            width: "160",
            align: "center"
          }, {
            header: _withCtx(() => _cache[3] || (_cache[3] = [_createElementVNode("span", {
              class: "column-label"
            }, "*", -1), _createTextVNode("研发阶段 ")])),
            default: _withCtx(scope => [_createVNode(_component_el_form_item, {
              rules: rules.stage,
              prop: "list.".concat(scope.$index, ".stage"),
              class: "s-label"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: scope.row.stage,
                "onUpdate:modelValue": $event => scope.row.stage = $event,
                filterable: "",
                placeholder: "请选择",
                onBlur: () => validateField('stage', scope.$index),
                onChange: () => validateField('stage', scope.$index)
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stageList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.label
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "onBlur", "onChange"])]),
              _: 2
            }, 1032, ["rules", "prop"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "unit",
            label: "发酵规模",
            width: "160",
            align: "center"
          }, {
            header: _withCtx(() => _cache[4] || (_cache[4] = [_createElementVNode("span", {
              class: "column-label"
            }, "*", -1), _createTextVNode("发酵规模 ")])),
            default: _withCtx(scope => [_createVNode(_component_el_form_item, {
              rules: rules.scale,
              prop: "list.".concat(scope.$index, ".scale"),
              class: "s-label"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: scope.row.scale,
                "onUpdate:modelValue": $event => scope.row.scale = $event,
                filterable: "",
                placeholder: "请选择",
                onBlur: () => validateField('scale', scope.$index),
                onChange: () => validateField('scale', scope.$index)
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scaleList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.label
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "onBlur", "onChange"])]),
              _: 2
            }, 1032, ["rules", "prop"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "项目有效期",
            width: "290",
            align: "center"
          }, {
            header: _withCtx(() => _cache[5] || (_cache[5] = [_createElementVNode("span", {
              class: "column-label"
            }, "*", -1), _createTextVNode("项目有效期 ")])),
            default: _withCtx(scope => [_createVNode(_component_el_form_item, {
              rules: rules.time,
              prop: "list.".concat(scope.$index, ".time"),
              class: "s-label"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: scope.row.time,
                "onUpdate:modelValue": $event => scope.row.time = $event,
                type: "daterange",
                "range-separator": "至",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期",
                style: {
                  "width": "260px"
                },
                onChange: e => changeTime(e, scope.$index)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
              _: 2
            }, 1032, ["rules", "prop"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "remark",
            label: "备注",
            width: "180",
            align: "center"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input, {
              modelValue: scope.row.remark,
              "onUpdate:modelValue": $event => scope.row.remark = $event
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center"
          }, {
            default: _withCtx(scope => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_popconfirm, {
              width: "200",
              "confirm-button-text": "确认",
              "cancel-button-text": "取消",
              "icon-color": "#626AEF",
              title: "确认删除?",
              onConfirm: $event => handle_del_row(scope.$index)
            }, {
              reference: _withCtx(() => _cache[6] || (_cache[6] = [_createElementVNode("span", {
                class: "iconfont icon-shanchu"
              }, null, -1)])),
              _: 2
            }, 1032, ["onConfirm"])])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])]),
        _: 1
      }, 8, ["model"]), !_ctx.isOnlyRead ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "add-item",
        onClick: _cache[0] || (_cache[0] = $event => handle_add_row())
      }, _cache[7] || (_cache[7] = [_createElementVNode("span", {
        class: "iconfont icon-tianjia"
      }, null, -1), _createTextVNode(" 添加 ")]))) : _createCommentVNode("", true)])]);
    };
  }
};